module.exports = __webpack_public_path__ + "bddbecdac17a76a6df64b44ac438e82c.png";